import React from "react";
import "./Vision.css";

const Vision: React.FC = () => {
  return (
    <section className="vision-section">
      {/* Content Container */}
      <div className="vision-container">
        <p className="vision-text">
          "At <span className="vision-brand">Bixton</span>, we’re dedicated to providing durable lighting solutions
          with sustainable leading-edge technology through an inspired team of
          professionals."
        </p>
        {/* <p className="vision-author">Director</p> */}
      </div>
    </section>
  );
};

export default Vision;
